export default __webpack_public_path__ + "static/media/foremlogo.4b9b479e.svg";